$(function(){
    var $button = $('.wp-block-button__link');

    $button.each(function( ){
        var text = $(this).text();

        if (text.toLowerCase().indexOf("clear") >= 0) {
            $(this).prepend('<i class="fas fa-trash-alt"></i>');
        }

        if (text.toLowerCase().indexOf("save") >= 0) {
            $(this).prepend('<i class="far fa-save"></i>');

            if (window.matchMedia('(max-width: 768px)').matches) {
                $(this).html('<i class="far fa-save"></i> SAVE');
            }
        }

        if (text.toLowerCase().indexOf("start") >= 0) {
            $(this).prepend('<i class="fas fa-undo"></i>');
        }

    });
});